// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__qLyUc","buttons":"SendReceipts_buttons__V7YsV","email":"SendReceipts_email__1svKv","bookApptTitle":"SendReceipts_bookApptTitle__2uNzf"};